/* vc-welle.js: Skript der Section sections/vc-welle.liquid (VC Sections von VersagerClo).
   Liegt als eigene Datei vor, damit es nur auf Seiten lädt, auf denen die Section steht. Läuft einmal pro Seite,
   auch wenn die Section mehrmals vorkommt. Wartet auf die VC-Grundlage (vc-basis), falls sie noch fehlt. */
(function () {
  var geladen = window.VCJS = window.VCJS || {};
  if (geladen['vc-welle']) return;
  geladen['vc-welle'] = true;
  var los = function () {
  if (!customElements.get('vc-welle')) {
    var alleWellen = function () {
      document.querySelectorAll('vc-welle').forEach(function (w) { if (w.farbeHolen) w.farbeHolen(); });
    };
    var zeitWellen = null;
    var spaeterWellen = function () { clearTimeout(zeitWellen); zeitWellen = setTimeout(alleWellen, 120); };
    customElements.define('vc-welle', class extends HTMLElement {
      connectedCallback() { this.farbeHolen(); requestAnimationFrame(this.farbeHolen.bind(this)); }
      /** Nachbar-Section mit Inhalt (andere unsichtbare Sections wie Welle oder Abstand werden übersprungen). */
      nachbar(vor) {
        var ich = this.closest('.shopify-section');
        if (!ich) return null;
        var alle = Array.prototype.slice.call(document.querySelectorAll('.shopify-section'));
        var i = alle.indexOf(ich);
        for (var j = vor ? i + 1 : i - 1; j >= 0 && j < alle.length; j += vor ? 1 : -1) {
          if (alle[j].getBoundingClientRect().height > 4) return alle[j];
        }
        return null;
      }
      farbeHolen() {
        if (this.dataset.auto !== 'true' || !window.VC || !VC.farbeAnKante) { this.style.removeProperty('--farbe-ist'); return; }
        var hoch = this.dataset.richtung !== 'runter';
        var n = this.nachbar(hoch);
        var f = n ? VC.farbeAnKante(n, !hoch) : null;
        if (!f && !n) f = VC.seitenFarbe();
        if (f) this.style.setProperty('--farbe-ist', f); else this.style.removeProperty('--farbe-ist');
      }
    });
    window.addEventListener('load', alleWellen);
    window.addEventListener('resize', spaeterWellen);
    ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (n) { document.addEventListener(n, spaeterWellen); });
  }
  };
  if (window.VC && window.VC.melden) los(); else document.addEventListener('DOMContentLoaded', los);
})();
